import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "flex items-center gap-4 font-bold text-gray-900" }
const _hoisted_3 = { class: "flex gap-4" }

import { computed } from 'vue';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

import CalulationSegmentDeleteButton from '../components/CalulationSegmentDeleteButton.vue';

import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useCurrentCalculatorSegments } from '../composables/useCurrentCalculatorSegments';
import { useEstimatedSegments } from '../composables/useEstimatedSegments';

import type { CalculationSegment } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationSegmentsTable',
  setup(__props) {

const { currentCalculation } = useCurrentCalculation();
const { getSegmentFirstViewId, getSegmentById, getSegmentFirstGroupId } =
  useCurrentCalculatorSegments();
const { segmentRules } = useEstimatedSegments();

const segmentRulesMap = computed(() => {
  const map = new Map();

  if (!segmentRules.value) {
    return map;
  }

  segmentRules.value.forEach((segment) => {
    map.set(segment.id, segment);
  });

  return map;
});

function getRuleValueBySlug(segmentId: number, slug: string): string {
  const segment = segmentRulesMap.value.get(segmentId);

  if (!segment?.rules) {
    return '-';
  }

  const rule = segment.rules.find((r: any) => r.slug === slug);

  if (!rule) {
    return '-';
  }

  return rule.unit ? `${rule.eval} ${rule.unit}` : String(rule.eval);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode(" Formularze ")),
      _createVNode(_component_RouterLink, {
        class: "ml-auto",
        to: {
          name: 'SelectSegmentView',
          params: {
            clientId: _ctx.$route.params.client_id,
            calculationId: _ctx.$route.params.calculationId,
            calculatorId: _ctx.$route.params.calculatorId,
          },
        }
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            class: "font-semibold",
            size: "small",
            outlined: ""
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "pi pi-plus" }, null, -1),
              _createTextVNode(" Dodaj technologię ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (_unref(currentCalculation))
      ? (_openBlock(), _createBlock(_unref(DataTable), {
          key: 0,
          class: "overflow-hidden rounded-xl border border-gray-200 [&__.p-row-odd]:bg-gray-50",
          value: _unref(currentCalculation)?.calculation_segments,
          removableSort: "",
          tableStyle: "min-width: 50rem"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              field: "id",
              header: "ID",
              sortable: "",
              style: {"width":"5%"}
            }),
            _createVNode(_unref(Column), {
              header: "Nazwa",
              style: {"width":"50%"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_unref(getSegmentById)(data.segment_id)?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Wartość",
              style: {"width":"15%"}
            }, {
              body: _withCtx(({ data }: { data: CalculationSegment }) => [
                _createTextVNode(_toDisplayString(getRuleValueBySlug(data.segment_id, 'cena-zestawu-brutto-dla-klienta')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "dotation",
              header: "Dotacja",
              style: {"width":"10%"}
            }, {
              body: _withCtx(({ data }: { data: CalculationSegment }) => [
                _createTextVNode(_toDisplayString(getRuleValueBySlug(data.segment_id, 'dotacja-czyste-powietrze')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "",
              style: {"width":"10%"}
            }, {
              body: _withCtx(({ data }: { data: CalculationSegment }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_RouterLink, {
                    to: {
                name: 'CalculationViewItems',
                params: {
                  ..._ctx.$route.params,
                  segmentId: data.segment_id,
                  viewId: _unref(getSegmentFirstViewId)(data.segment_id),
                  groupId: _unref(getSegmentFirstGroupId)(data.segment_id)?.groupId,
                },
              }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        class: "!p-2",
                        size: "small",
                        severity: "secondary",
                        outlined: ""
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "pi pi-pen-to-square" }, null, -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (!_unref(getSegmentById)(data.segment_id)?.is_required)
                    ? (_openBlock(), _createBlock(CalulationSegmentDeleteButton, {
                        key: 0,
                        calculationUuid: _unref(currentCalculation).uuid,
                        segmentId: data.segment_id
                      }, null, 8, ["calculationUuid", "segmentId"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})